<template>
   <div id="panel-fiche" class="panel panel-default" role="container">
<!--      <elementHeader-->
<!--              :key="'text-element-header'"-->
<!--              :data="fiche.data.elements[0].childElements[0].childElements[0]"-->
<!--              :elindex="0"-->
<!--              v-if="fiche.data.elements[0].childElements[0].childElements[0].type === 'header'"-->
<!--      ></elementHeader>-->
<!--      <ficheData-->
<!--              :key="'text-element-data'"-->
<!--              :data="fiche.data.elements[1].childElements[0]"-->
<!--              :elindex="1"-->
<!--      ></ficheData>-->
      <conteneur
        :elements="fiche.data.elements"
      ></conteneur>
      <edit-element
        @elementUpdate="handleTitleUpdate"
        ref="editTitle"
      />
  </div>
</template>

<script>
import conteneur from './conteneur'
import ficheData from './ficheData'
import editElement from '../modal/editElement'
import { mapActions } from 'vuex'
import { defaultTitleStyle } from '../../../config/constanteUse'

export default {
  components: {
    conteneur,
    ficheData,
    editElement
  },
  props: {
    fiche: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      defaultTitleStyle
    }
  },
  methods: {
    ...mapActions(['updateFicheTitle']),
    openEditTitleModal (data) {
      this.$refs['editTitle'].open(data)
    },
    handleTitleUpdate (data) {
      this.updateFicheTitle(data)
    }
  }
}
</script>

<style lang="scss" scoped>
  #panel-fiche {
    margin-top: 0;
      padding-left:21px;
      padding-right:80px;
  padding-top:50px;
    padding-bottom: 20px;
    margin-bottom: 20px;
    position: relative;
    &.panel[role="container"] {
      border: 1px solid #2b3085 !important;
    }
    .panel-heading {
      height: 60px;
      text-transform: uppercase;
    }
    .top-action {
      position: absolute;
      top: 0;
      right: 0;
      height: 35px;
      margin-bottom: 20px;
      button{
        background-color: #EFEFEF;
        border: 1px solid rgba(0, 0, 0, 0.1);
        color: #959393;
        border-radius: 0;
        font-weight: normal;
        box-shadow: none !important;
        &:hover{
          color: #10608F;
          border-color: #10608F;
        }
        &:active{
          background-color: #EFEFEF;
          color: #10608F;
          border: 1px solid #10608F;
        }
      }
    }
    h2{
      font-size: 18px;
      font-weight: bold;
      text-transform: uppercase;
    }
    h3{
      font-size: 16px;
      font-weight: bold;
    }
    .row-no-padding > [class*="col-"]:first-of-type {
        padding-right: 0;
    }
    .row-no-padding > [class*="col-"]:first-of-type {
        border-right: 1px solid #D8E6F1;
    }
    .row-no-padding > [class*="col-"]:last-of-type {
        padding-left: 0;
        border: none;
    }
    font-family: "Open sans";
    .panel{
        border: none;
        box-shadow: none;
        border-radius: 0;
        margin-bottom: 15px;
    }
    &.panel[role="container"]{
      border: 1px solid lightgray;
    }
    .add-element{
      width: 100%;
      border: 1px dashed #666;
      float: left;
      padding: 1rem 0;
      color: #000;
      opacity: 0.4;
      text-decoration: none;
      box-sizing: border-box;
      transition-property: all;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/edit/ficheEspaceContentEdit.vue